import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cliente } from '../api/dto/cliente';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { Administradora } from '../api/dto/administradora';

@Injectable({
    providedIn: 'root',
})
export class AdministradoraService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'administradoras/';


    listarAdminstradoras(): Observable<Administradora[]> {
        return this.http.get<Administradora[]>(this.url);
    }

    listarAdminstradorasPorUsuarioId(id?: number): Observable<Administradora[]> {
        return this.http.get<Administradora[]>(this.url + 'usuario/' + id);
    }

    buscarAdminstradoraPorId(id?: number): Observable<Administradora> {
        return this.http.get<Administradora>(this.url + id);
    }

    buscarPorCnpj(cnpj?: string): Observable<Administradora> {
        return this.http.get<Administradora>(this.url + "cnpj/" + cnpj);
    }

    salvar(administradora?: Administradora): Observable<Administradora> {
        return this.http.post<Administradora>(this.url, administradora);
    }

    atualizar(administradora?: Administradora, id?: number): Observable<Administradora> {
        return this.http.put<Administradora>(this.url + id, administradora);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${id}`);
    }

}